import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  AJOUTER_SERVICE_PARTNER,
  RECHERCHER_SERVICE_PARTNER,
} from "../../Utils/constant";
import { store } from "../../services/service";
import { useStoreServicePartner } from "../../store/storeServicePartner";

export const UpdateServicePartner = ({ item }) => {
  const servicePartner = useStoreServicePartner();
  const [error, setError] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const submit = (data) => {
    setIsSubmit(true);
    store(AJOUTER_SERVICE_PARTNER, "application/json", { ...data, id: item.id })
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("fermer").click();
          toast.success("Mis à jour");
          servicePartner.getData(
            `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`
          );
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setError(err.response.data.donnee);
      });
  };

  useEffect(() => {
    if (item) {
      reset();
    }
  }, [item, reset]);

  return (
    <div>
      <form onSubmit={handleSubmit(submit)} className="px-2">
        <p className="text-sm text-red-600">{error}</p>
        <div className="my-4 space-y-4">
          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Designation
            </label>
            <input
              {...register("designation", { required: true })}
              defaultValue={item?.designation}
              type="text"
              placeholder=""
              className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
            />
            {errors.designation && (
              <span className="text-sm text-rose-600">
                Ce champs est obligatoire
              </span>
            )}
          </div>

          <button
            type="submit"
            disabled={isSubmit ? true : false}
            onClick={() => {
              setError(null);
            }}
            className={`${
              !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
          >
            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </div>
  );
};
